const compareAscending = (a: string | number, b: string | number): number => (a < b ? -1 : a > b ? 1 : 0)

export const asc =
  <T>(keyFn: (a: T) => string | number) =>
  (a: T, b: T) =>
    compareAscending(keyFn(a), keyFn(b))

const compareDescending = (a: string | number, b: string | number): number => (a < b ? 1 : a > b ? -1 : 0)

export const desc =
  <T>(keyFn: (a: T) => string | number) =>
  (a: T, b: T) =>
    compareDescending(keyFn(a), keyFn(b))
